// Header.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="app-header">
      <div className="header-logo">
        <Link to="/" state={{ triggerAnimation: true }}>
          <img src="/dalijaus_logo.png" alt="CampingApp Logo" className="logo-img" />
        </Link>
      </div>
      <nav className="header-nav">
        <ul>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/terms">Terms of Use</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/responsible-travel">Responsible Traveling</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;